module.exports = __webpack_public_path__ + "static/media/dining.2196aa46.jpg";